import { useLocation } from 'react-router-dom';
import Breadcrumbs from './Breadcrumbs';
import { ProductTypeLabelMapping } from '../constant/constant';
import { BreadcrumsProps, ProductTypeFileds } from '../interface/interface';

function BackToPrevious() {
  const location = useLocation();
  const breadCrumb: BreadcrumsProps['data'] = [];

  function renderChildren(source: string) {
    switch (source) {
      case '/products':
        // eslint-disable-next-line no-case-declarations
        sessionStorage.setItem('selectedProductsTab', location.state.type);
        return (
          <>
            {ProductTypeLabelMapping[location.state.type as ProductTypeFileds]}
          </>
        );

      case '/non-script-range':
        return <>Non Script Range</>;

      default:
        return <>Home</>;
    }
  }

  if (location?.state?.from) {
    breadCrumb.push({
      tag: 'a',
      className: 'underline',
      href: location.state.from,
      children: renderChildren(location.state.from),
    });
  }

  // Default to all
  breadCrumb.push({
    tag: 'p',
    children: <>Product Details</>,
  });

  return (
    <div className="mt-4">
      <Breadcrumbs data={breadCrumb} />
    </div>
  );
}

export default BackToPrevious;
